var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"heading"},[_vm._v("Reverse DNS Lookup")]),_c('div',{staticClass:"subtitle"},[_vm._v("This page allows you to query for DNS records for a specific IP address.")]),_c('ReverseDNSLookup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }